import { render } from "./LoaderInside.vue?vue&type=template&id=bc373e9c&scoped=true"
import script from "./LoaderInside.vue?vue&type=script&lang=js"
export * from "./LoaderInside.vue?vue&type=script&lang=js"

import "./LoaderInside.vue?vue&type=style&index=0&id=bc373e9c&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc373e9c"]])

export default __exports__